/**
 * Tipi condivisi della selezione "CV anonimi", usata identica dalla ricerca
 * attiva e dal talent pool.
 */

/** Tetto dei candidati selezionabili in una volta. Sono anche gli slot avatar
 *  disegnati dalla barra flottante: cambiarlo cambia la UI. */
export const MAX_CV_SELECTION = 4;

/**
 * Il minimo che serve per mostrare un candidato nella barra e chiederne il CV.
 * Sia la riga di ricerca che l'entry del pool lo soddisfano già — è il motivo
 * per cui le due superfici possono condividere la stessa UI senza adattatori.
 */
export type CvCandidate = {
  /** Profile id del freelance: è questo che va al backend, non l'id del salvataggio. */
  id: string;
  full_name: string | null;
  avatar_url: string | null;
  job_title: string | null;
};

/**
 * Contratto della selezione. La ricerca attiva la tiene nello store persistito
 * (sopravvive alla navigazione verso il dettaglio), il pool in un segnale
 * locale alla vista: i componenti non sanno quale delle due stanno usando.
 */
export type CvSelection = {
  selected: () => CvCandidate[];
  count: () => number;
  remaining: () => number;
  isFull: () => boolean;
  isSelected: (id: string | number) => boolean;
  add: (candidate: CvCandidate) => void;
  remove: (id: string | number) => void;
  clear: () => void;
};
